<script setup lang="js">
import { watch } from 'vue';
import { storeToRefs } from 'pinia';

import { useModalStore } from '@/stores/modal.store';

const modalStore = useModalStore();
const { activeModal, modalParams, keepAliveComponents } = storeToRefs(modalStore);

watch(activeModal, (value) => {
  if (!value) {
    return document.body.classList.remove('modal-open');
  }

  document.body.classList.add('modal-open');
});

</script>

<template>
  <KeepAlive :include="keepAliveComponents">
    <component v-if="activeModal" :is="activeModal" v-bind="modalParams"/>
  </KeepAlive>
</template>
